// 海外TOP用のコントローラー
import ControllerBase from '../controller/page/_index'
import UiStore from '../store/_ui-store'

// ビューモデル
import FormStore from './store/_form-store'
import { FormSelect } from './_form-select'
import { FormUl } from './_form-ul'
import { GadgetDropdownSelect } from './_gadget_dropdown_select'

import { DatePicker } from './_datePicker'
import { TopRoomChange } from './_roomChange'
import { TopRoomsInfo } from './_roomsInfo'
import { GadgetButton } from './_gadget_button'
import { GadgetPeopleButton } from './_gadget_people_button'
import { DateUndecided } from './_dateUndecided'
import { FormStoreCtl } from './_form-store-ctl'
// import { TourForm } from '../const/_tour-from'
import { TourDetailRoomAllocation } from './_tour-detail-room-allocation'
import { objectToGet, numberToArray, saveData, loadData, removeData, dayJs } from '../functions'
import { numberToSelectData } from '../functions/tour'

import 'bootstrap/js/dist/dropdown'

export function Maker(obj) {
  const className = obj.className()
  return controller => {
    $(className).each((inex, element) => {
      obj($(element), controller)
    })
  }
}

/**
 * controller // コントローラー
 *
 * イベントの伝播やモデルの受渡しなど
 *
 * @returns {undefined}
 */
class MainController extends ControllerBase {
  constructor() {
    super('top')
  }

  /**
   * hook // オブジェクトをインスタンスにする
   *
   * @param {string} className // hookするjsのクラス名
   * @param {string} objectName // 登録されたobject名
   */
  hook(objectName, fragment = null) {
    const MyClassFunc = this.objList[objectName]
    // eventを初期化
    this.eventList[objectName] = []
    if (!fragment) fragment = $('html')
    if (MyClassFunc) MyClassFunc(this, fragment)
  }

  /**
   * hookAll.// viewModelの登録処理
   */
  hookAll() {
    Object.keys(this.objList).map(item => {
      this.hook(item)
    })
  }

  /**
   * hookCall // コントローラーのイベントを削除とclassインスタンスの登録
   *
   * @param {string} target // hookするjsのクラス名
   * @param {string} objectName // 登録されたobject名
   */
  hookCall(target, objectName) {
    this.off(objectName)
    this.hook(target, objectName)
  }

  /**
   * addObj // objectを登録する
   *
   * @param {class} MyClassObject // classオブジェクト
   * @param {string} objectName // 呼び出しの名前
   */
  addObj(MyClassObject) {
    const objectName = MyClassObject.name()
    this.objList[objectName] = (controller, fragment) => {
      const className = MyClassObject.className()
      fragment.find(className).each((inex, element) => {
        return new MyClassObject($(element), controller)
      })
    }
  }

  /**
   * collectObj // オブジェクトを登録する
   */
  collectObj() {
    // 登録は一度でOK
    if (Object.keys(this.objList).length !== 0) return null
    this.addObj(FormSelect)
    this.addObj(DatePicker)
    this.addObj(TopRoomChange)
    this.addObj(TopRoomsInfo)
    this.addObj(TourDetailRoomAllocation)
    this.addObj(GadgetButton)
    this.addObj(GadgetPeopleButton)
    this.addObj(DateUndecided)
    this.addObj(FormStoreCtl)
    this.addObj(FormUl)
    this.addObj(GadgetDropdownSelect)
  }

  init() {
    // this.trigger('tourDetailRoomAllocation')
    FormStore.init(FormStore)
    // FormStore.hookUpdateAfter('roomNum', () => this.trigger('tourDetailRoomAllocation'))

    for (let i = 1; i <= 9; i++) {
      FormStore.addForm(`room${i}people`, {
        value: 1,
        type: 'select',
        format: 'number',
        list: numberToSelectData(1, 9),
        updateAfter: () => this.trigger('tourDetailRoomAllocation'),
      })
      for (let c = 1; c <= 9; c++) {
        FormStore.addForm(`room${i}age${c}`, {
          value: 20,
          type: 'select',
          format: 'number',
          list: numberToSelectData(0, 99),
          updateAfter: () => this.trigger('tourDetailRoomAllocation'),
        })
      }
    }
    FormStore.updateData('room1people', 2)

    // 入力結果を読み取り
    const now = dayJs().unix()
    let roomList = { list: [[20, 20]], limit: now }
    const load = loadData('roomList')
    if (load !== null) roomList = load
    // 60分経過したlocalStorageを削除
    if (now > roomList.limit) {
      removeData('roomList')
      roomList.list = [[20, 20]]
    }
  }

  /**
   * facade // インスタンスの登録処理
   */
  facade() {}

  /**
   * on // eventの登録
   *
   * @param {string} objectName // eventリストに登録するオブジェクトの名前
   * @param {string} eventName
   * @param {function} callback
   */
  on(objectName, eventName, callback) {
    const event = `custom:${this.name}:${eventName}`
    // eventリストに登録
    this.eventList[objectName].push(event)
    $(window).on(event, callback)
  }

  /**
   * off // オブジェクト名に紐づくeventの削除
   *
   * @param {string} objectName // オブジェクト名
   */
  off(objectName) {
    const events = $._data($(window).get(0), 'events')
    const eventList = this.eventList[objectName]
    if (!eventList) return
    eventList.map(eventName => {
      if (eventName in events) $(window).off(eventName)
    })
  }

  /**
   * trigger // イベントのトリガー
   *
   * @param {string} eventName
   */
  trigger(eventName, data = null) {
    $(window).trigger(`custom:${this.name}:${eventName}`, data)
  }

  hookAfterInit() {
    this.trigger('tourDetailRoomAllocation')
  }

  roomAllocation() {
    const rooms = []
    const roomNum = FormStore.getData('roomNum', 1)
    for (let i = 1; i <= roomNum; i++) {
      rooms.push({
        no: i,
        ages: numberToArray(FormStore.getData(`room${i}people`, 0), 1),
      })
    }

    return {
      rooms,
      errMsg: this.allocationErrorFlg(),
    }
  }

  /**
   * peopleCheck.//人数のチェック
   */
  peopleCheck() {
    const roomNum = FormStore.getData('roomNum', 0)
    let adult = 0
    let child = 0
    let toddler = 0
    for (let i = 1; i <= roomNum; i++) {
      const people = FormStore.getData(`room${i}people`, 0)
      for (let c = 1; c <= people; c++) {
        const age = UiStore.getData(`room${i}age${c}r`, 0)
        if (age > 11) {
          adult++
        } else if (age > 1) {
          child++
        } else {
          toddler++
        }
      }
    }
    const totalNum = adult + child + toddler
    return totalNum > 9 || toddler > adult
  }

  /**
   * ageCheck.// 年齢のチェック
   */
  ageCheck() {
    const roomList = this.roomList()
    let result = false
    roomList.map(room => {
      const adult = room.filter(age => age > 11).length
      if (adult === 0) result = true
    })
    return result
  }

  /**
   * roomList. 部屋のリストを返す
   */
  roomList() {
    const list = []
    const roomNum = FormStore.getData('roomNum', 0)
    for (let i = 1; i <= roomNum; i++) {
      const rooms = []
      //   const people = FormStore.getData(`room${i}people`, 0)
      //   const room = []
      //   for (let c = 1; c <= people; c++) {
      const adt = UiStore.getData(`room${i}age20r`, 0)
      if (adt > 0) {
        for (let roomA = 1; roomA <= adt; roomA++) {
          rooms.push(20)
        }
      }
      const chd = UiStore.getData(`room${i}age6r`, 0)
      if (chd > 0) {
        for (let roomC = 1; roomC <= chd; roomC++) {
          rooms.push(6)
        }
      }
      const inf = UiStore.getData(`room${i}age0r`, 0)
      if (inf > 0) {
        for (let roomI = 1; roomI <= inf; roomI++) {
          rooms.push(0)
        }
      }
      console.log('rooms', rooms)
      // room.push(age)
      //   }
      if (rooms.length) list.push(rooms)
    }
    return list
  }

  /**
   * lockRooms // 更新時の部屋割データを設定
   */
  lockRooms() {
    // すべての部屋の人数
    const roomNum = FormStore.getData('roomNum', 0)
    const list = this.roomList()
    console.log('lockRooms', list)
    // 初期化
    UiStore.updateData(
      'lockRooms',
      {
        roomNum: roomNum,
        roomList: list,
      },
      true,
    )

    // ローカルストレージへ保存
    const limit = dayJs().add(60, 'minute').unix()
    saveData('roomList', { list, limit })
  }

  /**
   * minAgeCheck.// 最低年齢のチェック
   */
  minAgeCheck() {
    const currentHotel = UiStore.getData('currentHotel', [])
    const minCheckInAge = objectToGet(currentHotel, 'minCheckInAge', 0)
    const minGuestAge = objectToGet(currentHotel, 'minGuestAge', 0)
    const minCheckInAgeCheck = this.minCheckInAgeCheck(minCheckInAge)
    const minGuestAgeCheck = this.minGuestAgeCheck(minGuestAge)
    UiStore.updateData('minCheckInAge', minCheckInAgeCheck)
    UiStore.updateData('minGuestAge', minGuestAgeCheck)
    if (!minCheckInAgeCheck || !minGuestAgeCheck) {
      UiStore.updateData('soldOutAir', true)
      UiStore.updateData('soldOutHotel', true)
      this.trigger('TourDetailMessage')
      this.trigger('TourDetailShow')
      this.trigger('roomApply')
      this.trigger('flightApply')
      return false
    }
    return true
  }

  /**
   * minCheckInAgeCheck.// 最低チェックイン年齢チェック
   *
   */
  minCheckInAgeCheck(minCheckInAge = 0) {
    if (minCheckInAge === 0) return true
    const roomList = this.roomList()
    const roomArray = roomList.map(room => {
      let result = true
      const adult = room.filter(function (age) {
        if (age >= minCheckInAge) return true
      }).length
      if (adult === 0) result = false
      return result
    })
    if (roomArray.includes(false)) return false
    return true
  }

  /**
   * minGuestAgeCheck.// 宿泊可能な最低年齢チェック
   */
  minGuestAgeCheck(minGuestAge = 0) {
    if (minGuestAge === 0) return true
    const roomList = this.roomList()
    let result = true
    roomList.map(room => {
      const child = room.filter(function (age) {
        if (age < minGuestAge) return true
      }).length
      if (child > 0) result = false
    })
    return result
  }

  /**
   * allocationErrorFlg. // 部屋割りのエラーを判定
   */
  allocationErrorFlg() {
    if (this.ageCheck()) return 'age'
    if (this.peopleCheck()) return 'people'
    return null
  }
}
export default new MainController()
